/**
 * Unit.documents の保存前処理。
 *
 * UnitOtherDocuments で保持された documents 配列の中で、新規ファイル
 * (`_pendingFile: File`) を S3 (presigned URL) にアップロードして s3_key に置換し、
 * BE に送信できる純粋な UnitDocument[] を返す。
 *
 * - 既存ファイル (s3_key 入り) はそのまま通過
 * - 空のラベル枠 (file_name === "" のダミー) は除去
 */

import type { UnitDocument } from "@ippon/shared-types";
import { uploadFileWithPresignedUrl } from "@/utils/fileUpload";

type DraftDoc = UnitDocument & { _pendingFile?: File };

export async function uploadPendingUnitDocuments(
  documents: UnitDocument[] | undefined,
  propertyId: string,
): Promise<UnitDocument[]> {
  if (!documents || documents.length === 0) return [];

  const result: UnitDocument[] = [];
  for (const raw of documents) {
    const draft = raw as DraftDoc;

    // 空のラベル枠 (UI 上のグループタイトルだけのダミー) は送信しない
    if (!draft.file_name && !draft._pendingFile) continue;

    if (draft._pendingFile instanceof File) {
      const s3Key = await uploadFileWithPresignedUrl(
        draft._pendingFile,
        propertyId,
      );
      result.push({
        document_id: draft.document_id,
        category: draft.category,
        label: draft.label,
        file_name: draft._pendingFile.name,
        s3_key: s3Key,
        uploaded_at: new Date().toISOString(),
      });
    } else {
      // 既存 / s3_key 確定済み
      result.push({
        document_id: draft.document_id,
        category: draft.category,
        label: draft.label,
        file_name: draft.file_name,
        s3_key: draft.s3_key,
        uploaded_at: draft.uploaded_at,
      });
    }
  }
  return result;
}
